/** AUTO GENERATED FILE, DO NOT CHANGE MANUALLY */
/** SEE: api/ConstClassFactory */
export const ModuleType = {
dataType: 'dataType',
module: 'module',
moduleModule: 'moduleModule',
moduleSettings: 'moduleSettings',
system: 'system',
widget: 'widget',
}